module.exports = __webpack_public_path__ + "9ddfd8d35358fcb6cae882008281eb73.jpg";